import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isEditionOneOf } from './is-edition-one-of';

/**
 * Eligibility for Jira Premium PaymentDetailsPopup
 * (Jira in trial, not a reverse trial, with an experience URL).
 */
export function isEligibleForPremiumPaymentDetailsPopup(
	context: EditionAwarenessContextType,
): boolean {
	const {
		product,
		edition,
		isInTrial,
		isInReverseTrial,
		addPaymentDetailsExperienceUrl,
		isInCollection,
		invoiceableStatus,
		canAddPaymentDetails,
	} = context;

	if (fg('ea_audience_and_timing_refactor')) {
		return Boolean(
			!isInCollection &&
			isEditionOneOf(edition, ['premium']) &&
			product === 'jira' &&
			isInTrial &&
			!isInReverseTrial &&
			addPaymentDetailsExperienceUrl &&
			invoiceableStatus === 'NOT_INVOICEABLE' &&
			canAddPaymentDetails,
		);
	}

	return Boolean(
		isEditionOneOf(edition, ['premium']) &&
		product === 'jira' &&
		isInTrial &&
		!isInReverseTrial &&
		addPaymentDetailsExperienceUrl,
	);
}
